module.exports = __webpack_public_path__ + "media/campus-1.efa61d11.mp4";